import { z } from 'zod';

export const schemaAssignSegmentResponse = z.object({
    contact_id: z.string().optional(),
    created_at: z.string().optional(),
    expires_at: z.string().optional(),
    key: z.string(),
    organization_id: z.string(),
    sub_type: z.enum(['default', 'location', 'campaign']).optional(),
    type: z.string().optional(),
    updated_at: z.string().optional(),
});

export type SchemaAssignSegmentResponse = z.infer<typeof schemaAssignSegmentResponse>;
